import { useDebouncedValue } from '@mantine/hooks';
import { useState } from 'react';

import { Nomenclature } from '@feature/nomenclature';

export function useFilterOptions(list: Nomenclature[] | undefined) {
  return (list ?? []).map(it => ({
    value: String(it.id),
    label: it.name,
  }));
}

interface UseFilterReturn {
  onChange: (newV: string | null) => void;
  value: string | null;
  id: string | null;
}

export function useFilter(): UseFilterReturn {
  const [value, setValue] = useState<string | null>(null);

  return {
    id: value,
    value,
    onChange: (newV: string | null) => setValue(newV),
  };
}

export function useNumberFilter(initialValue: string | number = '') {
  const [value, setValue] = useState<string | number | undefined>(initialValue);
  const [debounced] = useDebouncedValue(value, 700);

  return {
    // eslint-disable-next-line no-nested-ternary
    item: debounced != null ? (debounced !== '' ? Number(debounced) : null) : null,
    value,
    onChange: (newV: string | number) => setValue(newV),
  };
}

export function useBooleanFilter(initialValue = false) {
  const [checked, setChecked] = useState(initialValue);

  // null rather than false, so the axios serializer's skipNulls drops the param when the toggle is off.
  const item: true | null = checked ? true : null;

  return {
    item,
    checked,
    onChange: (newV: boolean) => setChecked(newV),
  };
}

export * from './SelectFilter';
export * from './NumberFilter';
export * from './BooleanFilter';
